<header class="dialog-header">
  <h3 class="header-heading">
    <span class="card-type" [ngClass]="form.get('cardType').value">
      <i [ngClass]="cardIcon"></i>
      {{ cardLabel }}
    </span>
    <span class="heading-text" *ngIf="data.action === CardActions.SUBSCRIBE">{{ 'pages.user-cards.create.heading' | translate }}</span>
    <span class="heading-text" *ngIf="data.action === CardActions.RENEW">{{ 'pages.user-cards.renew.heading' | translate }}</span>
    <span class="heading-text" *ngIf="data.action === CardActions.LINK">{{ 'pages.user-cards.link.heading' | translate }}</span>
  </h3>
  <button 
    class="close-button" 
    (click)="closeDialog()"
  ></button>
</header>

<div class="progress" *ngIf="steps.length > 0">
  <div
    *ngFor="let step of steps; let i = index"
    class="step-progress"
    [class.active]="stepIndex === i"
  >
    <div class="chip">{{ i + 1 }}</div>
    <h4 class="step-text">{{ step }}</h4>
  </div>
</div>

<div class="dialog-content">

  <div class="step" *ngIf="stepIndex === 0">
    <app-step-info-not-connected [form]="form" [subTypes]="subTypes" [instructionsStepsInfo]="instructionsStepsInfo" [cardActions]="data.action"></app-step-info-not-connected>
  </div>

  <div class="step" *ngIf="stepIndex === 1">
    <app-step-confirmation-not-connected [form]="form" [cardActions]="data.action" [instructionsStepsConfirmation]="instructionsStepsConfirmation"></app-step-confirmation-not-connected>
  </div>
</div>

<footer class="dialog-footer">
  <button
    *ngIf="stepIndex > 0"
    (click)="back()"
    class="bciti-inline-button back-button"
  >
    {{ 'pages.user-cards.common.button.back' | translate }}
  </button>
  <div class="spacer"></div>
  <button *ngIf="stepIndex === 0" 
    [disabled]="!validateInfoStep()"
    (click)="next()" 
    class="bciti-button bciti-button--blue">
    {{ 'pages.user-cards.common.button.next' | translate }}
  </button>
  <button *ngIf="stepIndex === 1" 
    [disabled]="!validateCardForm() || processingSubmit"
    (click)="submit()" 
    class="bciti-button bciti-button--blue">
    <span *ngIf="!processingSubmit">{{ 'pages.user-cards.common.button.submit' | translate }}</span>
    <mat-spinner *ngIf="processingSubmit" diameter="20"></mat-spinner>
  </button>
</footer>
